module.exports = __webpack_public_path__ + "static/media/nrw_calculation_icon.1c887b25.svg";